import { Privileges } from "./PrivilegeConstants";

export const hasAnyPrivilege = (privilegeList = [], keys = []) =>
    keys.some((key) => privilegeList?.includes(key));

export const FINANCES_KEYS = [
    Privileges.MY_FINANCES.MANAGE_TRANSACTION,
    Privileges.MY_FINANCES.MANAGE_PAYOUT,
    Privileges.MY_FINANCES.MANAGE_ACCOUNT,
];

export const ADMIN_SETTINGS_KEYS = [
    ...FINANCES_KEYS,
    Privileges.REGISTRATION_SETUP.MANAGE_FORM_TEMPLATE,
    Privileges.PLAN.MANAGE_PLATFORM_PLAN,
    Privileges.PLAN.MANAGE_CLUB_PLAN,
    Privileges.PLAN.MANAGE_ONE_TIME_ACTIVATION_FEE,
    Privileges.CALENDAR_SETTING.MANAGE_COURT,
    Privileges.CALENDAR_SETTING.MANAGE_CLUB_TIME,
    Privileges.CALENDAR_SETTING.MANAGE_TIMEZONE_INTERVAL,
    Privileges.CLUB_SETUP.MANAGE_CLUB_PROFILE,
    Privileges.EVENT.MANAGE_EVENT,
    Privileges.ROSTER.MANAGE_ROSTER,
    Privileges.TEAM.MANAGE_TEAM,
];

export const canViewAdminSettings = (privilegeList = []) =>
    hasAnyPrivilege(privilegeList, ADMIN_SETTINGS_KEYS);

export const canAccessFinances = (privilegeList = []) =>
    hasAnyPrivilege(privilegeList, FINANCES_KEYS);
